<template>
  <div :class="['header-wrapper', { scrolled: st }]">

    <div>

      <header class="w">
        <div class="w-box">

          <div class="nav-logo">
            <router-link to="/login" title="医小智-牙嗖嗖"></router-link>
          </div>

          <!-- 菜单显示 -->
          <div class="menu-box">
            <div :class="user.isLogin == true?'nav-list-login':'nav-list'">
              <li v-for="(item,i) in navList" :key="i" class="nav-item-dropdown">
                <a :class="{active:common.navSelect.navIndex === i}" @click="changeNav(i,item)">{{item.navLabel}}</a>
                <!-- 下拉二级菜单 -->
                <ul class="nav-dropdown" v-if="item.navSubList && item.navSubList.length > 1">
                  <li v-for="(sub,j) in item.navSubList" :key="j" @click.stop="changeSubNav(j, sub)">
                    <a :class="{active: common.navSelect.navIndex === i && common.navSelect.navSubIndex === j}">{{sub.navLabel}}</a>
                  </li>
                </ul>
              </li>
            </div>
          </div>
          <div class="right-box">
            <div class="nav-login-btn" v-if="!user.isLogin" @click="toLogin">
              <svg class="login-icon" viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/></svg>
              登录
            </div>
            <div class="nav-aside" ref="aside" :style="user.isLogin == true?'opacity:1;':'opacity:0;'">
              <div class="user pr" v-if="user.isLogin">
                <div class="user-name-trigger">
                  <span class="user-avatar-small"
                        :style="user.avatar ? 'background-image:url(' + user.avatar + ')' : 'background-image:url(/static/images/default.png)'"></span>
                  <span class="user-name-text">{{user.contact || user.nickName || user.loginName}}</span>
                  <i class="arrow-down"></i>
                </div>
                <!-- 用户信息显示 start -->
                <div class="nav-user-wrapper pa">
                  <div class="nav-user-list">
                    <ul>
                      <li>
                        <router-link to="/user/information">基本信息</router-link>
                      </li>
                      <li>
                        <router-link to="/user/addressList">收货地址</router-link>
                      </li>
                      <li v-if="isCertified && user.userType !== '20'">
                        <router-link to="/user/inviteDesigner">邀约设计师</router-link>
                      </li>
                      <li v-if="isCertified && user.userType !== '20'">
                        <router-link to="/user/blockDesList">拉黑设计师</router-link>
                      </li>
                      <li>
                        <router-link to="/user/support">售后服务</router-link>
                      </li>
                      <li>
                        <a href="javascript:;" @click="clickLogout">退出账号</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- 用户信息显示 end -->
              </div>
              <!-- <div class="user pr">
                <router-link to="/user">个人中心</router-link>
                <div class="nav-user-wrapper pa" v-if="login">
                  <div class="nav-user-list">
                    <ul>
                      <li class="nav-user-avatar">
                        <div>
                          <span class="avatar" :style="{backgroundImage:'url('+userInfo.info.file+')'}">
                          </span>
                        </div>
                        <p class="name">{{userInfo.info.username}}</p>
                      </li>
                      <li>
                        <router-link to="/user/orderList">我的订单</router-link>
                      </li>
                      <li>
                        <router-link to="/user/information">账号资料</router-link>
                      </li>
                      <li>
                        <router-link to="/user/addressList">收货地址</router-link>
                      </li>
                      <li>
                        <router-link to="/user/support">售后服务</router-link>
                      </li>
                      <li>
                        <router-link to="/user/coupon">我的优惠</router-link>
                      </li>
                      <li>
                        <a href="javascript:;" @click="_loginOut">退出</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
              <!-- 购物车 start（暂时隐藏，后期启用）
              <div class="shop pr" @mouseover="cartShowState(true)" @mouseout="cartShowState(false)" ref="positionMsg">
                <div class="cart-trigger">
                  <svg class="cart-svg-icon" viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM7.16 14.26l.04-.12.94-1.7h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1 1 0 0 0 20.05 4H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7.42c-.14 0-.25-.11-.25-.25z"/></svg>
                  <span class="cart-badge" :class="{hidden: totalNum <= 0}">{{totalNum > 99 ? '99+' : totalNum}}</span>
                </div>
                <div class="nav-cart-dropdown pa" v-show="cart.showCart">
                  <div class="cart-dropdown-inner">
                    <div v-show="totalNum" class="cart-full">
                      <div class="cart-items-list">
                        <ul>
                          <li class="cart-item-row" v-for="(item,i) in cart.cartList" :key="i">
                            <div class="cart-item-thumb">
                              <img :src="item.productImg" @click="openProduct(item.productId)">
                            </div>
                            <div class="cart-item-info">
                              <h4 class="cart-item-name" @click="openProduct(item.productId)">{{item.productName}}</h4>
                              <div class="cart-item-meta">
                                <span class="cart-item-price">¥{{item.salePrice}}</span>
                                <span class="cart-item-qty">×{{item.productNum}}</span>
                              </div>
                            </div>
                            <div class="cart-item-action">
                              <button class="cart-del-btn" @click="delGoods(item.productId)" title="删除">
                                <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
                              </button>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <div class="cart-dropdown-footer">
                        <div class="cart-summary">
                          <span>共 <em>{{totalNum}}</em> 件商品</span>
                          <span class="cart-total-price">合计：<em>¥{{totalPrice.toFixed(2)}}</em></span>
                        </div>
                        <button class="go-cart-btn" @click="toCart">去购物车</button>
                      </div>
                    </div>
                    <div v-show="!totalNum" class="cart-empty">
                      <svg viewBox="0 0 24 24" width="48" height="48" fill="#ccc"><path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM7.16 14.26l.04-.12.94-1.7h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49A1 1 0 0 0 20.05 4H5.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h12v-2H7.42c-.14 0-.25-.11-.25-.25z"/></svg>
                      <p>购物车还是空的，快去挑选商品吧</p>
                    </div>
                  </div>
                </div>
              </div>
              购物车 end -->
              <!-- <div class="msg pr" v-if="user.isLogin">
                <router-link to="/msg">消息中心</router-link>
                <span class="msg-num">
                  <i class="num"></i>
                </span>
                <div class="nav-user-wrapper pa active" v-if="user.isLogin">

                  <div class="nav-user-list">

                    <div class="full">
                      <div class="nav-msg-items">

                        <ul>

                          <li class="clearfix">
                            <a>
                              <div class="msg-item">
                                <div class="msg-item-desc">系统消息</div>
                                <span class="msg-item-num">
                                  <i class="num">12</i>
                                </span>
                              </div>
                            </a>
                          </li>

                          <li class="clearfix">
                            <a>
                              <div class="msg-item">
                                <div class="msg-item-desc">通知消息</div>
                                <span class="msg-item-num">
                                  <i class="num">8</i>
                                </span>
                              </div>
                            </a>
                          </li>

                          <li class="clearfix">
                            <a>
                              <div class="msg-item">
                                <div class="msg-item-desc">私信消息</div>
                                <span class="msg-item-num">
                                  <i class="num">1</i>
                                </span>
                              </div>
                            </a>
                          </li>

                        </ul>
                      </div>
                      <div class="nav-msg-total">
                        <a>
                          查看全部
                        </a>
                      </div>

                    </div>

                  </div>

                </div>
              </div> -->

              <!--              <div class="cart pr">
                <router-link to="/msg">消息中心</router-link>
                <span class="msg-num">
                  <i class="num"></i>
                </span>
                <div class="nav-user-wrapper pa active" v-if="user.isLogin">
                  <div class="nav-user-list">
                    <div class="full">
                      <div class="nav-msg-items">
                        <ul>
                          <li class="clearfix">
                            <a>
                              <div class="msg-item">
                                <div class="msg-item-desc">系统消息</div>
                                <span class="msg-item-num">
                                  <i class="num">12</i>
                                </span>
                              </div>
                            </a>
                          </li>
                          <li class="clearfix">
                            <a>
                              <div class="msg-item">
                                <div class="msg-item-desc">通知消息</div>
                                <span class="msg-item-num">
                                  <i class="num">8</i>
                                </span>
                              </div>
                            </a>
                          </li>
                          <li class="clearfix">
                            <a>
                              <div class="msg-item">
                                <div class="msg-item-desc">私信消息</div>
                                <span class="msg-item-num">
                                  <i class="num">1</i>
                                </span>
                              </div>
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div class="nav-msg-total">
                        <a>
                          查看全部
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </header>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="600px" center append-to-body custom-class="auth-apply-dialog">
      <div slot="title" class="header-title">
        <div style="padding:15px 20px;">认证申请</div>
      </div>
      <!-- <div style=""> -->
      <div style="display: flex; align-items: center; justify-content:space-around;height: 300px;">
        <div class="item itme1">
          <a @click="factory">
            <div class="t fiex f-18">
              <div class="t2 center"><img src="/static/images/zc11.png">
                <!-- <p class="mag-t-20">认证诊所/工厂进行下单</p> -->
              </div>
            </div>
            <div class="p">诊所/工厂认证</div>
          </a>
        </div>
        <div class="item itme2">
          <a @click="designer">
            <div class="t fiex f-18">
              <div class="t2 center"><img src="/static/images/zc22.png">
                <!-- <p class="mag-t-20">认证成为设计师进行接单</p> -->
              </div>
            </div>
            <div class="p">设计师认证</div>
          </a>
        </div>
      </div>
      <!-- </div> -->
    </el-dialog>
    <!-- 退出确认对话框 -->
    <el-dialog title="提示" :visible.sync="logoutDialogVisible" width="400px" center :modal="false" custom-class="logout-confirm-dialog">
      <p style="text-align: center; font-size: 14px; color: #333; padding: 10px 0;">确定要退出账号吗？</p>
      <span slot="footer" style="text-align: center;">
        <el-button size="small" @click="logoutDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmLogout">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  mapState
} from 'vuex'
import {
  setStore,
  getStore,
  removeStore
} from '/utils/storage'
import YButton from '../components/YButton.vue'
import navList from "/assets/config/navList.js";
import navDemList from "/assets/config/navDemList.js";
import navDesList from "/assets/config/navDesList.js";
export default {
  data() {
    return {
      // currentNav: -1,
      // currentSubNav: -1,
      st: false,
      navList: [],
      navSubList: [],
      positionL: 0,
      positionT: 0,
      msgNum: 0,
      token: '',
      cartShow: false,
      dialogVisible: false,
      logoutDialogVisible: false,
      template: '99',
      selWidth:'110px',
    }
  },
  components: {
    YButton
  },
  computed: {
    // ...mapState([
    //   'cartList', 'login', 'receiveInCart', 'showCart', 'userInfo'
    // ]),
    ...mapState(['common', 'user', 'cart']),
    // 是否“认证通过”：已登录 且 非审核中(02) 且 非驳回/未认证(99) 且 非未认证账号(userType 99)
    isCertified() {
      var u = this.user;
      return !!(u.isLogin && u.authFlag !== '02' && u.authFlag !== '99' && u.userType !== '99');
    },
    // 计算价格
    totalPrice() {
      var totalPrice = 0
      this.cart.cartList && this.cart.cartList.forEach(item => {
        totalPrice += (item.productNum * item.salePrice)
      })
      return totalPrice
    },
    // 计算数量
    totalNum() {
      var totalNum = 0
      this.cart.cartList && this.cart.cartList.forEach(item => {
        totalNum += (item.productNum)
      })
      return totalNum
    }
  },
  methods: {
    toLogin(){
      this.$router.push('/login');
    },
    loadNav() {
      var u = this.user;
      // 仅“认证通过”的诊所/工厂(10)、设计师(20)加载带二级菜单的配置
      // 审核中(authFlag=02)、审核未通过/驳回(authFlag=99)、未认证账号(userType=99)、未登录等一律使用默认 navList（不显示二级菜单）
      if (this.isCertified && u.userType === '10') {
        this.navList = navDemList;
      } else if (this.isCertified && u.userType === '20') {
        this.navList = navDesList;
      } else {
        this.navList = navList;
      }
      this.syncNavFromRoute();
    },
    // 根据当前路由同步菜单选中状态
    syncNavFromRoute() {
      if (!this.navList || this.navList.length === 0) return;
      var path = this.$route.path;
      var query = this.$route.query;
      var pathName = path.replace(/^\//, '');
      var hasQuery = Object.keys(query).length > 0;

      var foundNavIndex = -1;
      var foundSubIndex = -1;

      // 第一步：遍历所有 nav 的子菜单，精确匹配 path + query
      for (var i = 0; i < this.navList.length; i++) {
        var item = this.navList[i];
        if (!item.navSubList) continue;
        for (var j = 0; j < item.navSubList.length; j++) {
          var sub = item.navSubList[j];
          if (sub.linkUrl !== pathName) continue;
          if (hasQuery) {
            if (!sub.query) continue;
            var qMatch = true;
            for (var qk in query) {
              if (sub.query[qk] !== query[qk]) { qMatch = false; break; }
            }
            if (qMatch) { foundNavIndex = i; foundSubIndex = j; break; }
          } else {
            if (!sub.query) { foundNavIndex = i; foundSubIndex = j; break; }
          }
        }
        if (foundNavIndex !== -1) break;
      }

      // 第二步：子菜单未匹配时，尝试匹配主菜单项自身的 linkUrl
      if (foundNavIndex === -1) {
        for (var i = 0; i < this.navList.length; i++) {
          if (this.navList[i].linkUrl === pathName) {
            foundNavIndex = i;
            foundSubIndex = 0;
            break;
          }
        }
      }

      // 第三步：回退 - 无 query 时取第一个 linkUrl 匹配的子菜单
      if (foundNavIndex === -1 && !hasQuery) {
        for (var i = 0; i < this.navList.length; i++) {
          var item = this.navList[i];
          if (!item.navSubList) continue;
          for (var j = 0; j < item.navSubList.length; j++) {
            if (item.navSubList[j].linkUrl === pathName) {
              foundNavIndex = i;
              foundSubIndex = 0;
              break;
            }
          }
          if (foundNavIndex !== -1) break;
        }
      }

      if (foundNavIndex !== -1) {
        this.$store.commit('common/recordNav', { navIndex: foundNavIndex, navSubIndex: foundSubIndex >= 0 ? foundSubIndex : 0 });
        var matchedNav = this.navList[foundNavIndex];
        if (matchedNav && matchedNav.navSubList) {
          this.navSubList = matchedNav.navSubList;
        }
      } else if (this.$route.meta.SubNav) {
        // 有 SubNav 但完全未匹配：保持当前选中状态
        if (this.common.navSelect.navIndex === -1) {
          this.$store.commit('common/recordNav', { navIndex: 0, navSubIndex: 0 });
        }
        var currentNav = this.navList[this.common.navSelect.navIndex];
        if (currentNav && currentNav.navSubList) {
          this.navSubList = currentNav.navSubList;
        }
      }
    },
    // 记录主导航栏
    changeNav(index, item) {
      localStorage.removeItem('matchUpload');
      if(index!=0){
        sessionStorage.clear();
      }
      this.$store.commit('common/recordNav', {
        navIndex: index,
        navSubIndex: 0
      })
      this.navSubList = this.navList[index].navSubList;

      if(item.navLabel == 'Online设计平台'&&this.user.authFlag == '00'){
        if (this.user.isLogin) {

          if (this.user.userType === '10') {
            window.open('//' + window.location.host + '/#/order/create?catalogId=' + index)
          }
          if (this.user.userType === '20') {
            window.open('//' + window.location.host + '/#/order/mall')
          }

          if (this.user.userType === '99') {
            this.$yxz.msg('账号未认证，请提交认证资料', 'error')

            if (this.user.authFlag == '00') {
              this.dialogVisible = true
            }
            if (this.user.authFlag == '02') {
              this.dialogVisible = true
            }
            if (this.user.authFlag == '99') {
              this.dialogVisible = true
            }
          }

        } else {

          this.$yxz.msg('未登录或登录状态已过期,请重新登录', 'error')
          var that = this;
          setTimeout(function() {
            that.$yxz.to('/login')
          }, 1500);
        }
      }else if(item.navLabel == 'Online设计平台'&&this.user.authFlag == '02'){
        this.$message({
          message: '您的认证信息正在审核中，请稍后重试...',
          type: 'success'
        });
      }else if(item.navLabel == 'Online设计平台'&&this.user.authFlag == '99'){
        this.$yxz.msg('账号未认证或认证被驳回，请提交认证资料', 'error')
        this.dialogVisible = true;
      }else{
        this.linkTo(item);
      }
    },
    // 记录子导航栏
    changeSubNav(index, item) {
      this.$store.commit('common/recordNav', {
        navIndex: this.common.navSelect.navIndex,
        navSubIndex: index
      })
      this.linkTo(item);
      sessionStorage.clear();
    },
    linkTo(item) {
      if (item.linkType === 1) {
        this.$yxz.to('/' + item.linkUrl)
      } else if (item.linkType === 2) { // 站内跳转(新窗口)
        var url = '//' + window.location.host + '/#/' + item.linkUrl;
        if (item.query) {
          var qs = [];
          for (var k in item.query) { qs.push(k + '=' + item.query[k]); }
          if (qs.length > 0) url += '?' + qs.join('&');
        }
        window.open(url)
      } else if (item.linkType === 9) {
        this.$router.push({
          path: "/" + item.linkUrl,
          query: item.query
        })
      } else { // 站外跳转
        window.open(item.linkUrl)
      }
    },
    // 退出登陆 - 显示对话框
    clickLogout() {
      this.logoutDialogVisible = true;
    },
    // 确认退出
    confirmLogout() {
      this.logoutDialogVisible = false;
      this.$api.post({
        url: '/logout',
        data: {
          token: this.token
        }
      }).then(res => {
        this.$store.dispatch('user/logout');
        this.$store.commit('common/resetNav');
        this.loadNav();
        this.$yxz.to("/home");
        this.$yxz.msg("退出成功");
      })
      sessionStorage.clear()
    },
    // 控制顶部吸顶
    navFixed() {
      var st = document.documentElement.scrollTop || document.body.scrollTop
      this.st = st >= 30
      // 计算小圆当前位置
      let num = document.querySelector('.cart-badge')
      if (num) {
        this.positionL = num.getBoundingClientRect().left
        this.positionT = num.getBoundingClientRect().top
        this.$store.commit('cart/addanimation', {
          cartPositionL: this.positionL,
          cartPositionT: this.positionT
        })
      }
    },
    // 购物车显示
    cartShowState(state) {
      this.$store.commit('cart/showcart', {
        showCart: state
      })
    },
    // 登陆时获取一次购物车商品
    _getCartList() {
      // getCartList({userId: getStore('userId')}).then(res => {
      //   if (res.success === true) {
      //     setStore('buyCart', res.result)
      //   }
      //   // 重新初始化一次本地数据
      // }).then(this.$store.commit("cart/initcart"))
    },
    toCart() {
      this.$router.push({
        path: '/cart'
      })
    },
    // 删除商品
    delGoods(productId) {
      if (this.user.login) { // 登陆了
        cartDel({
          userId: getStore('userId'),
          productId
        }).then(res => {
          this.$store.commit('cart/editcart', {
            productId
          })
        })
      } else {
        this.$store.commit('cart/editcart', {
          productId
        })
      }
    },
    openProduct(productId) {
      window.open('//' + window.location.host + '/#/goodsDetails?productId=' + productId)
    },
    designer() {
      this.$yxz.to('/designerAuth')
      this.dialogVisible = false
    },
    factory() {
      this.$yxz.to('/factoryAuth')
      this.dialogVisible = false
    },
  },
  watch: {
    '$route': {
      handler: function () {
        var self = this;
        this.$nextTick(function () {
          self.syncNavFromRoute();
        });
      },
      deep: true
    },
    // 登录状态/用户类型/认证状态变化时，重新加载导航（保证二级菜单按认证状态显隐）
    'user.isLogin': function () {
      this.loadNav();
    },
    'user.userType': function () {
      this.loadNav();
    },
    'user.authFlag': function () {
      this.loadNav();
    }
  },
  mounted() {
    this.token = getStore('token')
    if (this.login) {
      this._getCartList()
    } else {
      this.$store.commit("cart/initcart")
    }
    this.loadNav();
    if(this.$route.fullPath.includes('/order/orthodonticsCreateOrder')||
      this.$route.fullPath.includes('/order/active/bracket')){
      this.navSubList = this.navList[1].navSubList;
    }
  }

}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "../assets/style/theme";
@import "../assets/style/mixin";

.move_in_cart {
  animation: mymove .5s ease-in-out;
}

@keyframes mymove {
  0% {
    transform: scale(1)
  }

  25% {
    transform: scale(.8)
  }

  50% {
    transform: scale(1.2)
  }

  75% {
    transform: scale(.9)
  }

  100% {
    transform: scale(1)
  }
}

@-moz-keyframes mymove {
  0% {
    transform: scale(1)
  }

  25% {
    transform: scale(.8)
  }

  50% {
    transform: scale(1.2)
  }

  75% {
    transform: scale(.9)
  }

  100% {
    transform: scale(1)
  }
}

@-webkit-keyframes mymove {
  0% {
    transform: scale(1)
  }

  25% {
    transform: scale(.8)
  }

  50% {
    transform: scale(1.2)
  }

  75% {
    transform: scale(.9)
  }

  100% {
    transform: scale(1)
  }
}

@-o-keyframes mymove {
  0% {
    transform: scale(1)
  }

  25% {
    transform: scale(.8)
  }

  50% {
    transform: scale(1.2)
  }

  75% {
    transform: scale(.9)
  }

  100% {
    transform: scale(1)
  }
}

.header-wrapper {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: transparent;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  transition: background 0.35s ease, box-shadow 0.35s ease;

  &.scrolled {
    background: rgba(255, 255, 255, 0.98);
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }
}

header {
  height: 70px;
  z-index: 30;
  position: relative;
  overflow: visible;
}

.w-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  width: 100%;
  max-width: 1220px;
  margin: 0 auto;

  .nav-logo {
    position: relative;
    height: 70px;
    display: flex;
    align-items: center;

    >a {
      background: url(/static/images/yxz.png) no-repeat 100%;
      background-size: cover;
      display: block;
      @include wh(130px, 50px);
      text-indent: -9999px;
      background-position: 0 0;
    }

  }


  .menu-box {
    flex: 1;
    // margin: 0 50px;
  }

  .nav-list,.nav-list-login {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex: 1;

    > li {
      list-style: none;
    }

    a {
      color: black;
      display: block;
      font-size: 17px;
      padding: 10px 0;
      text-align: center;
      border-radius: 5px;
      cursor: pointer;

      &:hover {
        color: #1890ff;
      }

      &.active {
        font-weight: bold;
        color: #1890ff;
      }
    }
  }

  .nav-list{
    margin-left: 0;
    a{
      padding: 10px 12px;
      white-space: nowrap;
    }
  }
  .nav-list-login{
    a{
      padding: 10px 12px;
      white-space: nowrap;
    }
  }

  // 下拉二级菜单
  .nav-item-dropdown {
    position: relative;

    // 悬停区域桥接：防止鼠标移到下拉菜单途中断开
    > a {
      position: relative;
      z-index: 201;

      &::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 0;
        right: 0;
        height: 8px;
        background: transparent;
      }
    }

    .nav-dropdown {
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%) translateY(6px);
      min-width: 130px;
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
      padding: 6px 0;
      z-index: 1000;
      list-style: none;
      margin: 0;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s;
      pointer-events: none;

      // 顶部桥接区域
      &::before {
        content: '';
        position: absolute;
        top: -8px;
        left: 0;
        right: 0;
        height: 8px;
        background: transparent;
      }

      // 小三角指示器
      &::after {
        content: '';
        position: absolute;
        top: -6px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
        filter: drop-shadow(0 -1px 1px rgba(0,0,0,0.06));
      }

      li {
        list-style: none;
        padding: 0;
        margin: 0;

        a {
          display: block;
          padding: 9px 20px;
          font-size: 16px;
          color: #555;
          white-space: nowrap;
          text-align: center;
          border-radius: 0;
          transition: background 0.15s ease, color 0.15s ease;
          width: auto;
          cursor: pointer;

          &:hover {
            background: #f0f7fa;
            color: #1890ff;
          }

          &.active {
            color: #1890ff;
            font-weight: 500;
            background: #f0f7fa;
          }
        }
      }
    }

    // 悬停时显示下拉菜单
    &:hover .nav-dropdown {
      opacity: 1;
      visibility: visible;
      transform: translateX(-50%) translateY(0);
      pointer-events: auto;
    }
  }

  .nav-aside {
    position: relative;

    &.fixed {
      // width: 262px;
      position: fixed;
      // left: 50%;
      // margin-left: 458px;
      right: calc((100vw - 1220px)/2);
      margin-top: 0;
      z-index: 32;
      top: -46px;
      -webkit-transform: translate3d(0, 59px, 0);
      transform: translate3d(0, 59px, 0);
      -webkit-transition: -webkit-transform .3s cubic-bezier(.165, .84, .44, 1);
      transition: transform .3s cubic-bezier(.165, .84, .44, 1);
    }

  }

  .right-box {
    display: flex;
    align-items: center;
    padding-left: 20px;
    border-left: 1px solid #e8e8e8;
    margin-left: 10px;
  }

  .nav-aside {
    display: flex;
    align-items: center;
  }

  // 用户名触发器
  .user-name-trigger {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 8px 14px;
    border-radius: 6px;
    transition: background 0.2s;

    &:hover {
      background: #f5f7fa;
    }

    .user-avatar-small {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      flex-shrink: 0;
    }

    .user-name-text {
      font-size: 15px;
      color: #333;
      font-weight: 500;
      max-width: 90px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .arrow-down {
      display: inline-block;
      width: 0;
      height: 0;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 5px solid #999;
      transition: transform 0.2s;
    }

    &:hover .arrow-down {
      transform: rotate(180deg);
    }
  }

  .user {
    position: relative;

    &:hover {
      .nav-user-wrapper {
        opacity: 1;
        visibility: visible;
        transform: translate(-50%, 0);
        pointer-events: auto;
      }
    }

    li {
      list-style: none;
      padding: 0;
      margin: 0;

      a {
        display: block;
        padding: 10px 20px;
        font-size: 16px;
        color: #555;
        white-space: nowrap;
        text-align: center;
        transition: background 0.15s ease, color 0.15s ease;
        cursor: pointer;

        &:hover {
          background: #f0f7fa;
          color: #1890ff;
        }
      }
    }

    .nav-user-wrapper {
      width: 160px;
      transform: translate(-50%, 6px);
      left: 50%;
    }

    .nav-user-list {
      width: 160px;

      ul {
        padding: 0;
        margin: 0;
        list-style: none;
      }
    }
  }

  // 购物车容器
  .shop {
    position: relative;
    margin-left: 16px;
    z-index: 99;
  }

  // 购物车触发器
  .cart-trigger {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;
    color: #555;

    &:hover {
      background: #f5f7fa;
      color: #1890ff;
    }

    .cart-svg-icon {
      transition: color 0.2s;
    }

    .cart-badge {
      position: absolute;
      top: 2px;
      right: 2px;
      min-width: 18px;
      height: 18px;
      line-height: 18px;
      padding: 0 5px;
      font-size: 11px;
      font-weight: 600;
      color: #fff;
      background: #f5222d;
      border-radius: 9px;
      text-align: center;
      box-shadow: 0 1px 4px rgba(245, 34, 45, 0.4);
      transition: transform 0.3s;

      &.hidden {
        display: none;
      }
    }
  }

  // 购物车下拉面板
  .nav-cart-dropdown {
    right: -10px;
    width: 340px;
    padding-top: 12px;
    z-index: 200;

    .cart-dropdown-inner {
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 12px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
      overflow: hidden;

      // 小三角
      &::before {
        content: '';
        position: absolute;
        top: -6px;
        right: 70px;
        width: 12px;
        height: 12px;
        background: #fff;
        border: 1px solid #e8e8e8;
        border-bottom: none;
        border-right: none;
        transform: rotate(45deg);
      }
    }

    .cart-items-list {
      max-height: 320px;
      overflow-y: auto;
      padding: 0;

      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 2px;
      }

      .cart-item-row {
        display: flex;
        align-items: center;
        padding: 12px 16px;
        border-bottom: 1px solid #f5f5f5;
        transition: background 0.15s;

        &:hover {
          background: #fafafa;

          .cart-del-btn {
            opacity: 1;
          }
        }

        &:last-child {
          border-bottom: none;
        }
      }

      .cart-item-thumb {
        flex-shrink: 0;
        width: 64px;
        height: 64px;
        border-radius: 8px;
        overflow: hidden;
        margin-right: 12px;
        border: 1px solid #f0f0f0;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          cursor: pointer;
        }
      }

      .cart-item-info {
        flex: 1;
        min-width: 0;

        .cart-item-name {
          font-size: 13px;
          color: #333;
          line-height: 1.4;
          margin-bottom: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
          font-weight: 400;

          &:hover {
            color: #1890ff;
          }
        }

        .cart-item-meta {
          display: flex;
          align-items: center;
          gap: 8px;

          .cart-item-price {
            font-size: 14px;
            color: #f5222d;
            font-weight: 600;
          }

          .cart-item-qty {
            font-size: 12px;
            color: #999;
          }
        }
      }

      .cart-item-action {
        flex-shrink: 0;
        margin-left: 8px;

        .cart-del-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          border: none;
          background: transparent;
          color: #bbb;
          border-radius: 6px;
          cursor: pointer;
          opacity: 0;
          transition: all 0.2s;

          &:hover {
            background: #fff1f0;
            color: #f5222d;
          }
        }
      }
    }

    .cart-dropdown-footer {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 16px;
      background: #fafafa;
      border-top: 1px solid #f0f0f0;

      .cart-summary {
        font-size: 12px;
        color: #999;

        em {
          font-style: normal;
          color: #333;
          font-weight: 600;
        }

        .cart-total-price {
          margin-left: 12px;

          em {
            color: #f5222d;
            font-size: 16px;
          }
        }
      }

      .go-cart-btn {
        padding: 6px 20px;
        font-size: 13px;
        color: #fff;
        background: #1890ff;
        border: none;
        border-radius: 20px;
        cursor: pointer;
        transition: all 0.2s;
        white-space: nowrap;

        &:hover {
          background: #40a9ff;
          box-shadow: 0 2px 8px rgba(24, 144, 255, 0.35);
        }

        &:active {
          background: #096dd9;
        }
      }
    }

    .cart-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 48px 20px;

      svg {
        margin-bottom: 12px;
      }

      p {
        font-size: 13px;
        color: #999;
      }
    }
  }

}

// 用户信息弹出
.nav-user-wrapper {
  position: absolute;
  z-index: 1000;
  padding-top: 10px;
  opacity: 0;
  visibility: hidden;
  top: 100%;
  transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s;
  pointer-events: none;

  .nav-user-list {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
    padding: 6px 0;
    position: relative;

    // 顶部桥接区域
    &::before {
      content: '';
      position: absolute;
      top: -8px;
      left: 0;
      right: 0;
      height: 8px;
      background: transparent;
    }

    // 小三角指示器
    &::after {
      content: '';
      position: absolute;
      top: -6px;
      left: 50%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid #fff;
      filter: drop-shadow(0 -1px 1px rgba(0,0,0,0.06));
    }
  }
}

.display{
  display: none;
}
.header-title {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  background-color: #1890ff;
  color: #fff;
  font-size: 22px;
  font-weight: 600;
}
.item .p {
  background: #f56521;
  padding: 12px;
  text-align: center;
  border-radius: 10px;
  color: #fff;
}
.nav-login-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 30px;
  margin-top: 0;
  font-size: 15px;
  color: #1890ff;
  background: #fff;
  border-radius: 999px;
  border: 1px solid #1890ff;
  cursor: pointer;
  letter-spacing: 1px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.3s ease;
  user-select: none;

  .login-icon {
    flex-shrink: 0;
  }

  &:hover {
    color: #fff;
    background: #1890ff;
  }

  &:active {
    background: #096dd9;
    border-color: #096dd9;
  }
}

</style>
<style>
.logout-confirm-dialog {
  border-radius: 12px !important;
}
</style>



// WEBPACK FOOTER //
// MHeader.vue?bd4b7dd2